module.exports = __webpack_public_path__ + "static/img/book1.5e560cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book1.jpg
// module id = YM5E
// module chunks = 1